// extracted by mini-css-extract-plugin
module.exports = {"four-oh-four-container":"b_b","fourOhFourContainer":"b_b"};